export const theme = {
  colors: {
    primary: '#e74c3c',
    primaryHover: '#c0392b',
    secondary: '#2ecc71',
    secondaryHover: '#27ae60',
    background: '#f4f7f6',
    surface: '#ffffff',
    text: '#333333',
    textSecondary: '#666666',
    border: '#dddddd',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  }
};